// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Maintenance_centeredContainer_3K7NJ {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.Maintenance_container_2fwG9 {\r\n    margin-bottom: 30px;\r\n    padding: 0 15px;\r\n    text-align: center;\r\n}\r\n\r\n.Maintenance_container_2fwG9 img {\r\n    height: auto;\r\n    width: 128px;\r\n}\r\n", ""]);
// Exports
exports.locals = {
	"centeredContainer": "Maintenance_centeredContainer_3K7NJ",
	"container": "Maintenance_container_2fwG9"
};
module.exports = exports;
